export default {
  namespaced: true,
  video_watermarks: {
    title: 'Video Watermarks',
    title_main: "Video Watermark Settings",
    action_add: 'Create watermark',
    action_update: 'Update Watermark',
    title_location: 'Watermark Location',
    fields: {
      name: {
        label: 'Watermark name',
        placeholder: 'Watermark name'
      },
      tenant: {
        label: 'Tenant',
        placeholder: 'Tenant'
      },
      image: {
        label: 'Select Image',
        hint: 'Drag and drop an image'
      },
      opacity: {
        label: 'Image opacity'
      },
      text_lines: {
        label: 'Line #'
      },
      image_pos: {
        label: 'Image Position'
      },
      text_pos: {
        label: 'Text position'
      },
      show_live_video: {
        label: 'Show in live video'
      },
      show_recorded_video: {
        label: 'show in recorded video'
      },
      text_rotation: {
        label: 'Text rotation'
      },
      text_opacity: {
        label: 'Text opacity'
      },
      text_color: {
        label: 'Text color'
      },
    },
    subtitle_1: 'Text',
    subtitle_2: 'Positioning',
    subtitle_3: 'Font',
    placeholders_options: {
      ph1: 'UNIQUE_ID',
      ph2: 'CURRENT_DATE',
      ph3: 'CURRENT_TIME',
      ph4: 'OPERATOR_NAME',
      ph5: 'EMAIL_OPERATOR',
      ph6: 'TENANT',
      ph7: 'CENTER',
      ph8: 'SECTOR',
    },
    position_options: {
      pos1: 'Top Left Corner',
      pos2: 'Top Right Corner',
      pos3: 'Lower Left Corner',
      pos4: 'Lower Right Corner',
      pos5: 'Grid',
    },
    messages: {
      success_created: 'Watermark successfully created',
      success_updated: 'Watermark successfully updated',
    },
    btns: {
      delete_image: 'Delete Image',
      create: 'Save',
      update: 'Update',
    }
  }
}
